/*
 * @Description:
 * @Autor: xiaona.wang
 * @Date: 2021-08-25 23:12:25
 * @LastEditors: xiaona.wang
 * @LastEditTime: 2021-09-28 17:39:18
 */
import request from "@/utils/request";
const requestUrl = `${window.env.scimSystem}/api/v1`;
const application = {
  // 更新应用信息
  updateApplication: data => request({
    url: `${requestUrl}/api/v1/application/updateTenantApplication`,
    method: "put",
    data
  }),
  // 获取系统logo及标题
  getTitle: () => request({
    url: `${requestUrl}/tenant/current`,
    method: "get"
  }),
  // 更新系统logo及标题
  updateTenant: data => request({
    url: `${requestUrl}/tenant/app-info`,
    method: "put",
    data
  }),
  // 保存用户设置 admin/api/v1/user/layout-config
  saveUserSetting: data => request({
    url: `${requestUrl}/user/layout-config`,
    method: "post",
    data
  }),
  // 查询用户布局 /admin/api/v1/user/layout-config
  getUserSetting: () => request({
    url: `${requestUrl}/user/layout-config`,
    method: "get"
  })
};
export { application };
